<template>
    <div>
        <div v-if="editorVisible" class="flex items-baseline gap-2 px-2">
            <input
                v-model="name"
                class="input input-primary input-sm"
                data-cy="acc-name-input"
                placeholder="Kontonavn"
            >
            <input
                v-model="bankAccountNo"
                class="input input-primary input-sm"
                data-cy="acc-number-input"
                placeholder="Kontonummer"
            >
            <UButton
                data-cy="save-button"
                :disabled="!isValid"
                @click="save"
            >
                Lagre
            </UButton>
            <UButton color="neutral" variant="subtle" @click="hideEditor">Avbryt</UButton>
            <div v-if="!isValid && bankAccountNo">Ugyldig bankkontonummer</div>
        </div>
        <slot v-else :show-editor="showEditor"/>
    </div>
</template>

<script setup lang="ts">

import {computed, ref} from 'vue'
import {createBankAccount, fetchBankAccounts, validateBban} from '@/bank/bank-account.service'

const editorVisible = ref(false)

const name = ref('')
const bankAccountNo = ref('')

const showEditor = () => {
    clear()
    editorVisible.value = true
}

const isValid = computed(() => validateBban(bankAccountNo.value))

const hideEditor = () => {
    clear()
    editorVisible.value = false
}

const save = () => {
    createBankAccount({
        name: name.value,
        bban: bankAccountNo.value
    })
        .then(fetchBankAccounts)
        .then(hideEditor)
}


const clear = () => {
    name.value = ''
    bankAccountNo.value = ''
}

</script>

<style scoped>

</style>